import { Stack } from '@mui/material'
import DashboardEditIcon from 'assets/DashboardEditIcon'

import { useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import {
	cancelDashboardEdit,
	saveDashboardWidgets,
	saveWidgetSettings,
	toggleDashboardEditMode,
} from 'store/dashboardSlice'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { OutlinedButton } from 'ui/buttons/OutlinedButton'

import { TypographyHeader14 } from 'ui/typography/TypographyHeader14'
import { TypographyHeaderExtra } from 'ui/typography/TypographyHeaderExtra'

export const DashboardEditControls = () => {
	const dispatch = useAppDispatch()
	const { isEditMode, rows } = useAppSelector(state => state.dashboardSlice)
	const { userData, userDataPending } = useAppSelector(
		state => state.userReducer,
	)
	const [hovered, setHovered] = useState(false)

	const serverName = process.env.REACT_APP_SERVER_NAME
	const isShowEditControls = serverName === 'https://api.cowvision.ru/'

	const toggleButtonHover = () => {
		setHovered(prev => !prev)
	}

	return (
		<Stack
			width='100%'
			direction='row'
			justifyContent='space-between'
			alignItems='center'
		>
			{userDataPending ? (
				<Skeleton width={200} height={34} />
			) : (
				<TypographyHeaderExtra>
					{userData?.company?.title}
				</TypographyHeaderExtra>
			)}

			{isShowEditControls && (
				<Stack direction='row' alignItems='center' gap='24px'>
					{isEditMode && (
						<TypographyHeader14
							onClick={() => dispatch(cancelDashboardEdit())}
							sx={{ color: COLORS.main, cursor: 'pointer' }}
						>
							Отменить
						</TypographyHeader14>
					)}
					<OutlinedButton
						width={'178px'}
						height={'40px'}
						onClick={() => {
							if (isEditMode) {
								dispatch(saveDashboardWidgets())
								dispatch(saveWidgetSettings(rows))
							}
							dispatch(toggleDashboardEditMode())
						}}
						onMouseEnter={toggleButtonHover}
						onMouseLeave={toggleButtonHover}
						sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}
					>
						<DashboardEditIcon hovered={hovered} />
						{isEditMode ? 'Сохранить' : 'Редактировать'}
					</OutlinedButton>
				</Stack>
			)}
		</Stack>
	)
}
